/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import IDeviceCredential = Models.IDeviceCredential;
    import IHalList = Application.Models.IHalList;
    import DeviceCredential = Application.Models.DeviceCredential;
    import HalConverter = Application.Models.HalConverter;
    import IHalElement = Application.Models.IHalElement;
    import INetworkNodeType = Application.Models.INetworkNodeType;
    import IDeviceCredentialSpec = Application.Models.IDeviceCredentialSpec;

    const CREDENTIALS_KEY: string = "credentials";

    /**
     * Login service class
     */
    export class DeviceCredentialsService {
        public static $name: string = "deviceCredentialsService";
        public static $inject: string[] = ["$q", "backendService", "networkNodeTypeService"];

        

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private deviceCredentialsUrl: string = this.backendBaseUrl + this.servicePath + 'deviceCredentials';
        private searchByHrefUrl: string =
            this.deviceCredentialsUrl + '/search/findAllByDeviceHref?'; // href=networkNodes/13
        // private searchByHrefAndNameUrl: string =
        //     this.deviceCredentialsUrl + '/search/findByDeviceHrefAndName?'; // name=private&href=networkNodes/13

        /**
         * Constructor
         */
        constructor(public $q: ng.IQService,
                    public backendService: BackendService,
                    public networkNodeTypeService: NetworkNodeTypeService) {
        }

        public getDeviceCredentialsFor(entity: Models.IEntity): ng.IPromise<DeviceCredential[]> {
            let simplifiedHref: string = Common.Utils.getSimplifiedHrefFromString(entity.href).substring(1);
            return this.backendService.get(this.searchByHrefUrl + "href=" + simplifiedHref)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<IDeviceCredential>>) => {
                    for (let res of (result.data._embedded as any).deviceCredentials) { // tslint:disable-line
                        res.href = (res as any)._links.self.href; // tslint:disable-line
                    }
                    let convertedList: Models.IPaginatedList<DeviceCredential>;
                    convertedList = HalConverter.convertPaginatedList(result.data, DeviceCredential.Empty);
                    let elements: DeviceCredential[] = convertedList.elements;
                    return elements.sort((a: IDeviceCredential, b: IDeviceCredential) => {
                        return Common.Utils.idFromHref(a.href) - Common.Utils.idFromHref(b.href);
                    });
                });
        }

        public saveCredential(deviceCredential: IDeviceCredential): ng.IPromise<DeviceCredential> {
            let url: string = deviceCredential.href;
            return this.backendService.put(url, deviceCredential)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IDeviceCredential>>) => {
                    let halElement: IHalElement<IDeviceCredential> = result.data;
                    return HalConverter.convertElement(halElement, DeviceCredential.Empty);
                });
        }

        public getDeviceCredentialSpecsById(nodeTypeId: number):  ng.IPromise<IDeviceCredentialSpec[]> {
            return this.networkNodeTypeService.findById(nodeTypeId).then((networkNodeType: INetworkNodeType) => {
                return this.getDeviceCredentialSpecs(networkNodeType);
            });
        }

        public getDeviceCredentialSpecs(networkNodeType: INetworkNodeType): IDeviceCredentialSpec[] {
            return networkNodeType.manifest[CREDENTIALS_KEY] as IDeviceCredentialSpec[];
        }

        public saveDefaultForCredentialSpec(nodeTypeId: number, credentialName: string, defaultValue: string): ng.IPromise<void> {
            return this.networkNodeTypeService.findById(nodeTypeId).then((networkNodeType: INetworkNodeType) => {
                const specs: IDeviceCredentialSpec[] = (networkNodeType.manifest[CREDENTIALS_KEY] as IDeviceCredentialSpec[]);
                specs.forEach((spec: IDeviceCredentialSpec) => {
                    if (spec.name === credentialName) {
                        spec.default = defaultValue;
                    }
                });
                this.networkNodeTypeService.update(networkNodeType);
            });
        }

    }
}